<app-base-dialog [bottomBarRightTemplate]="bottomBar">
	<div class="table-container">
		<table>
			<thead>
				<tr>
					<th>Stap</th>
					<th>Opmerking</th>
					<th>Resultaat</th>
					<th>Starttijd</th>
					<th>Eindtijd</th>
					<th>Doorlooptijd</th>
				</tr>
			</thead>
			<tbody>
				@for (jobrunDetail of jobrunDetails; track jobrunDetail.id) {
					<tr>
						<td>
							<span>
								{{ jobrunDetail.stap }}
							</span>
						</td>
						<td>
							<span>
								{{ jobrunDetail.opmerking }}
							</span>
						</td>
						<td>
							<span>
								@switch (jobrunDetail.success) {
									@case (undefined) {
										Bezig
									}
									@case (1) {
										Geslaagd
									}
									@case (0) {
										Gefaald
									}
								}
							</span>
						</td>
						<td>
							<span>
								{{ jobrunDetail.stapVa | date: "d-M-yyyy 'om' H:mm:ss" }}
							</span>
						</td>
						<td>
							<span>
								{{ jobrunDetail.stapTm | date: "d-M-yyyy 'om' H:mm:ss" }}
							</span>
						</td>
						<td>
							<span>
								{{ doorlooptijd(jobrunDetail.stapVa, jobrunDetail.stapTm, data.jobrunInstelling.totMet) }}
							</span>
						</td>
					</tr>
				} @empty {
					<tr>
						<td>
							<span> Geen details beschikbaar </span>
						</td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
					</tr>
				}
			</tbody>
		</table>
	</div>
	<ng-template #bottomBar>
		<app-button (clickit)="dialogRef.close()">Sluiten</app-button>
	</ng-template>
</app-base-dialog>
